class ReclassificacaoFiscal {
    get $inject() {
        return ['gql']
    }

    constructor(gql) {
        this.gql = gql
    }

    aggregateByConclusao(filialId, filter = {}) {
        const query = gql`
            query ReclassificacaoFiscalEstatisticas($filialId: Int!, $filter: ProdutoFilter) {
                filial(id: $filialId) {
                    id
                    estatisticas {
                        reclassificacao {
                            aggregateByConclusao(filter: $filter) {
                                pendente
                                aprovado
                                ncmDispensaCodigoBarras
                                naoReclassificado
                                reclassificado
                                classificacaoCorreta
                                classificacaoIncorreta                                
                                cestDivergente
                                exTipiDivergente
                                ncmDivergente
                                cestInvalido
                                exTipiInvalida
                                ncmInvalida
                                reprovado
                                invalidCodigoBarras
                                missingCodigoBarras
                                parametrosInconsistentes
                            }
                        }
                    }
                }
            }
        `

        return this.gql
            .query(query, { filialId: parseInt(filialId), filter })
            .then(({ filial: { estatisticas } }) => estatisticas)
            .then(({ reclassificacao: { aggregateByConclusao } }) => ({
                ...aggregateByConclusao,
                total: aggregateByConclusao.aprovado + aggregateByConclusao.reprovado + aggregateByConclusao.pendente
            }))
    }

    buildConclusaoTree(aggregateByConclusao) {
        return {
            'APROVADO': {
                count: aggregateByConclusao.aprovado,
                percent: this.percent(aggregateByConclusao.aprovado, aggregateByConclusao),
                children: {
                    'NAO_RECLASSIFICADO': {
                        count: aggregateByConclusao.naoReclassificado,
                        percent: this.percent(aggregateByConclusao.naoReclassificado, aggregateByConclusao)
                    },
                    'NCM_DISPENSA_CODIGO_BARRAS': {
                        count: aggregateByConclusao.ncmDispensaCodigoBarras,
                        percent: this.percent(aggregateByConclusao.ncmDispensaCodigoBarras, aggregateByConclusao)
                    },
                    'RECLASSIFICADO': {
                        count: aggregateByConclusao.reclassificado,
                        percent: this.percent(aggregateByConclusao.reclassificado, aggregateByConclusao),
                        children: {
                            'CLASSIFICACAO_CORRETA': {
                                count: aggregateByConclusao.classificacaoCorreta,
                                percent: this.percent(aggregateByConclusao.classificacaoCorreta, aggregateByConclusao)
                            },
                            'CLASSIFICACAO_INCORRETA': {
                                count: aggregateByConclusao.classificacaoIncorreta,
                                percent: this.percent(aggregateByConclusao.classificacaoIncorreta, aggregateByConclusao),
                                children: {
                                    'NCM_DIVERGENTE': {
                                        count: aggregateByConclusao.ncmDivergente,
                                        percent: this.percent(aggregateByConclusao.ncmDivergente, aggregateByConclusao)
                                    },
                                    'CEST_DIVERGENTE': {
                                        count: aggregateByConclusao.cestDivergente,
                                        percent: this.percent(aggregateByConclusao.cestDivergente, aggregateByConclusao)
                                    },
                                    'EX_TIPI_DIVERGENTE': {
                                        count: aggregateByConclusao.exTipiDivergente,
                                        percent: this.percent(aggregateByConclusao.exTipiDivergente, aggregateByConclusao)
                                    }
                                }
                            }
                        }
                    }
                }
            },
            'REPROVADO': {
                count: aggregateByConclusao.reprovado,
                percent: this.percent(aggregateByConclusao.reprovado, aggregateByConclusao),
                children: {
                    'INVALID_CODIGO_BARRAS': {
                        count: aggregateByConclusao.invalidCodigoBarras,
                        percent: this.percent(aggregateByConclusao.invalidCodigoBarras, aggregateByConclusao)
                    },
                    'MISSING_CODIGO_BARRAS': {
                        count: aggregateByConclusao.missingCodigoBarras,
                        percent: this.percent(aggregateByConclusao.missingCodigoBarras, aggregateByConclusao)
                    },
                    'PARAMETROS_INCONSISTENTES': {
                        count: aggregateByConclusao.parametrosInconsistentes,
                        percent: this.percent(aggregateByConclusao.parametrosInconsistentes, aggregateByConclusao),
                        children: {
                            'NCM_INVALIDA': {
                                count: aggregateByConclusao.ncmInvalida,
                                percent: this.percent(aggregateByConclusao.ncmInvalida, aggregateByConclusao)
                            },
                            'CEST_INVALIDO': {
                                count: aggregateByConclusao.cestInvalido,
                                percent: this.percent(aggregateByConclusao.cestInvalido, aggregateByConclusao)
                            },
                            'EX_TIPI_INVALIDA': {
                                count: aggregateByConclusao.exTipiInvalida,
                                percent: this.percent(aggregateByConclusao.exTipiInvalida, aggregateByConclusao)
                            }
                        }
                    }
                }
            },
            'TODOS': {
                count: aggregateByConclusao.total,
                percent: this.percent(aggregateByConclusao.total, aggregateByConclusao)
            }
        }
    }

    estatisticas(filialId) {
        const query = gql`
            query EstatisticasReclassificacao($filialId: Int!) {
                filial(id: $filialId) {
                    id
                    estatisticas {
                        reclassificacao {
                            totalCount: produtosCount
                            produtosCount(filter: { ativo: true })
                            aggregateByStatus(filter: { ativo: true }) {
                                pendente
                                problemasEncontrados
                                concluida
                                ncmDispensaCodigoBarras
                            }
                            aggregateByProblemas(filter: { ativo: true }) {
                                invalidCodigoBarras
                                missingCodigoBarras
                                ncmDivergente
                                cestDivergente
                                exTipiDivergente
                            }
                        }
                    }
                }               
            }
        `

        return this.gql
            .query(query, { filialId: parseInt(filialId) })
            .then(({ filial: { estatisticas } }) => estatisticas)
    }

    hasNovaReclassificacaoFeature(empresaId) {
        const query = gql`
            query CheckFeatureReclassificacaoFiscalByConclusao($empresaId: Int!, $feature: String!) {
                enabled: checkFeature(feature: $feature, empresaId: $empresaId)
            }
        `

        const variables = {
            empresaId: parseInt(empresaId),
            feature: "nova_reclassificacao_fiscal"
        }

        return this.gql
            .query(query, variables)
            .then(({ enabled }) => enabled)
    }

    percent(count, aggregateByConclusao) {
        return count * 100 / aggregateByConclusao.total
    } 
}

angular
    .module('eficienciaFiscalModule')
    .service('ReclassificacaoFiscal', ReclassificacaoFiscal)
